'use client';

import { useEffect } from 'react';
import { SliceZone } from '@prismicio/react';
import { PrivacyDocument } from '../../../../../prismicio-types';
import { useAnchor } from '@/hooks';
import { Container } from '@/components';
import { components } from '@/slices';

import styles from './privacy.module.scss';
import { scrollToAnchor } from '@/utils';

interface PrivacyProps {
  page: PrivacyDocument<string>;
}

export const Privacy = ({ page }: PrivacyProps) => {
  const anchor = useAnchor();

  useEffect(() => {
    if (!anchor) return;
    scrollToAnchor(anchor);
  }, [anchor]);

  return (
    <Container styles={styles.privacyContainer}>
      <SliceZone slices={page.data.slices} components={components} />
    </Container>
  );
};
